/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductCategoryDto } from '../../models/product-category-dto';

export interface ApiProductcategoryGuidGet$Params {
  guid: string;
  'api-version'?: string;
}

export function apiProductcategoryGuidGet(http: HttpClient, rootUrl: string, params: ApiProductcategoryGuidGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductCategoryDto>> {
  const rb = new RequestBuilder(rootUrl, apiProductcategoryGuidGet.PATH, 'get');
  if (params) {
    rb.path('guid', params.guid, {});
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductCategoryDto>;
    })
  );
}

apiProductcategoryGuidGet.PATH = '/api/productcategory/{guid}';
